import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './get-seatmaps.actions';
import { GetSeatmapsState } from './get-seatmaps.state';

/**
 * getSeatmaps initial state
 */
export const getSeatmapsInitialState: GetSeatmapsState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for GetSeatmaps Store
 */
export const getSeatmapsReducerFeatures: ReducerTypes<GetSeatmapsState, ActionCreator[]>[] = [
  on(actions.setGetSeatmaps, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateGetSeatmaps, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetGetSeatmaps, () => getSeatmapsInitialState),

  on(actions.cancelGetSeatmapsRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failGetSeatmaps, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setGetSeatmapsFromApi, actions.updateGetSeatmapsFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * GetSeatmaps Store reducer
 */
export const getSeatmapsReducer = createReducer(getSeatmapsInitialState, ...getSeatmapsReducerFeatures);
